export const hasPriceChanged = (oldPrice, newPrice) => {
    return oldPrice != newPrice
};